import { useMemo } from 'react';
import { CALENDAR_STATUS_LABELS, type CalendarColorPalette } from 'dashboard409a/common/constants/calendar';
import { ColorSelector, ColorSelectorConfig } from 'dashboard409a/components/ColorSelector';
import { CalendarPreview } from 'dashboard409a/components/ColorSelector/CalendarPreview';
import { toSolidColor, useColorPalette } from 'dashboard409a/hooks/useColorPalette';
import { ModelStatus } from 'dashboard409a/pages/Workboard/common/types';

const CalendarPreviewWrapper = ({ colorPalette }: { colorPalette: CalendarColorPalette }) => (
  <CalendarPreview colorPalette={colorPalette} />
);

const getModelStatusPaletteKeys = (): Array<keyof CalendarColorPalette> =>
  Object.keys(ModelStatus).filter(
    key => Number.isNaN(Number(key))
  ) as Array<keyof CalendarColorPalette>;

interface ModelsColorSelectorProps {
  onClose?: () => void;
}

const ModelsColorSelector = ({ onClose }: ModelsColorSelectorProps = {}) => {
  const config: ColorSelectorConfig<CalendarColorPalette> = useMemo(
    () => ({
      title: 'Calendar Color Palette',
      tooltip: 'Change Calendar Colors',
      useHook: useColorPalette,
      statusLabels: CALENDAR_STATUS_LABELS,
      sections: [
        {
          title: 'Model Status Colors',
          keys: getModelStatusPaletteKeys(),
        },
        {
          title: 'Calendar Style Colors',
          keys: ['BACKGROUND', 'BORDER', 'LABELS', 'WAITING'] as Array<keyof CalendarColorPalette>,
        },
      ],
      modalWidth: '500px',
      showPreview: true,
      previewComponent: (palette: CalendarColorPalette) => <CalendarPreviewWrapper colorPalette={palette} />,
      toSolidColor,
      onClose,
    }),
    [onClose]
  );

  return <ColorSelector config={config} />;
};

export default ModelsColorSelector;
